import styled from 'styled-components';

import S from '../variables';

export const StyledMoreButton = styled.button`
  width: 100%;
  height: 45px;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  text-transform: uppercase;
  background: ${S.accentGold};
  border: none;
  ${props =>
    props.butType === 'black'
      ? `text-transform: lowercase; color: #fff; background: ${S.mainBlackText};`
      : props.butType === 'white'
      ? `text-transform: lowercase; color: ${S.mainBlackText}; background: #fff; border: 1px solid ${S.mainBlackText};`
      : props.butType === 'red'
      ? `color: #fff; background: ${S.redText}; border: 1px solid ${S.redText};`
      : props.butType === 'white-UC'
      ? `color: ${S.mainBlackText}; background: #fff; border: 1px solid ${S.mainBlackText};`
      : ''}
  &:hover {
    background: ${props =>
      props.butType === 'black'
        ? S.hoverBlack
        : props.butType === 'white'
        ? S.hoverWhite
        : props.butType === 'red'
        ? S.redTextHover
        : S.hoverGold};
    ${props => props.butType === 'white' && 'color: white;'}
  }
  @media screen and (min-width: ${S.tablet}) {
    width: ${props => props.wd || '100%'};
    font-size: 16px;
  }
  &[disabled] {
    background: white;
    color: ${S.mainGreyText};
    cursor: not-allowed;
    border: 1px solid ${S.disabledBorder};
  }
  transition: background ${S.trFast}, color ${S.trFast};
`;
